// =============================================================================
// MeuDriver — Hook: Dados de fatura de booking
// =============================================================================

import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

// Formato retornado pela RPC get_booking_invoice_data
export interface BookingInvoiceData {
  booking_id: string
  booking_number: string
  student_name: string | null
  instructor_name: string | null
  scheduled_date: string | null
  scheduled_time: string | null
  vehicle_type: string | null
  total_amount: number | null
  platform_fee: number | null
  payment_status: string | null
  payment_method: string | null
  mp_payment_id: string | null
  created_at: string
  pickup_address: string | null
}

export function useBookingInvoice(bookingId: string | undefined) {
  return useQuery({
    queryKey: ['booking-invoice', bookingId],
    queryFn: async (): Promise<BookingInvoiceData> => {
      if (!bookingId) throw new Error('bookingId obrigatório')
      const { data, error } = await supabase.rpc('get_booking_invoice_data', {
        p_booking_id: bookingId,
      })
      if (error) throw new Error(error.message)
      return data as BookingInvoiceData
    },
    enabled: Boolean(bookingId),
    staleTime: 1000 * 60 * 10, // 10 min — dado estático
  })
}
